import * as React from 'react';
import { colors } from '../../../index';

const IconManage = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 13 13",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79 10a1.73 1.73 0 01-1.68 1.33 1.73 1.73 0 01-1.68-2.17c.2-.75.87-1.31 1.68-1.31A1.73 1.73 0 019.79 10m2.76-.85h-1.9A2.58 2.58 0 008.1 7c-1.28 0-2.33.94-2.53 2.16H.42a.42.42 0 000 .85h5.16a2.58 2.58 0 002.53 2.16c1.27 0 2.33-.94 2.53-2.16h1.9a.42.42 0 000-.85m-9.36-7c.2-.75.87-1.32 1.68-1.32a1.73 1.73 0 011.68 2.17 1.73 1.73 0 01-1.68 1.32 1.73 1.73 0 01-1.68-2.17m-2.76.85h1.9a2.58 2.58 0 002.54 2.16c1.27 0 2.33-.94 2.53-2.16h5.16a.42.42 0 000-.85H7.39A2.58 2.58 0 004.86 0C3.58 0 2.53.94 2.33 2.16H.42a.42.42 0 000 .85"
  }));
};

export default IconManage;